import React from "react";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { setPlanUpgradeNeededModalContext } from "../../redux";
import IDHFormattedMessage from "../components/IDHFormattedMessage/IDHFormattedMessage";
import OuterLink from "../components/OuterLink/OuterLink";
import { useCheckFeatureAccess } from "../subscription/subscriptionFunctions";
import { SubscriptionEntitlements } from "../subscription/subscriptionUtils";

import "./SidebarItem.scss";

interface Props {
  to?: string;
  messageId?: string;
  defaultMessage?: string;
  overrideHtml?: React.ReactNode;
  outerLink?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  subscriptionEntitlement?: SubscriptionEntitlements;
}

const SidebarItem: React.FC<Props> = ({
  to,
  messageId,
  defaultMessage,
  outerLink,
  children,
  onClick,
  overrideHtml,
  subscriptionEntitlement,
}) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const entitlementGranted = useCheckFeatureAccess(subscriptionEntitlement);

  if (overrideHtml) {
    return <>{overrideHtml}</>;
  }

  const renderContent = () => {
    if (!entitlementGranted && subscriptionEntitlement) {
      return (
        <span
          className="sidebar__item__span"
          onClick={() =>
            dispatch(setPlanUpgradeNeededModalContext(subscriptionEntitlement))
          }
        >
          {children}
          <span className="sidebar__item-text">
            {messageId ? (
              <IDHFormattedMessage
                id={messageId}
                defaultMessage={defaultMessage}
              />
            ) : (
              defaultMessage
            )}
          </span>
        </span>
      );
    }

    if (outerLink && to) {
      return (
        <OuterLink href={to}>
          {children}
          <span className="sidebar__item-text">
            {messageId ? (
              <IDHFormattedMessage
                id={messageId}
                defaultMessage={defaultMessage}
              />
            ) : (
              defaultMessage
            )}
          </span>
        </OuterLink>
      );
    }

    if (to) {
      return (
        <Link to={to}>
          {children}
          <span className="sidebar__item-text">
            {messageId ? (
              <IDHFormattedMessage
                id={messageId}
                defaultMessage={defaultMessage}
              />
            ) : (
              defaultMessage
            )}
          </span>
        </Link>
      );
    }

    return (
      <span className="sidebar__item__span" onClick={onClick}>
        {children}
        <span className="sidebar__item-text">
          {messageId ? (
            <IDHFormattedMessage
              id={messageId}
              defaultMessage={defaultMessage}
            />
          ) : (
            defaultMessage
          )}
        </span>
      </span>
    );
  };

  return (
    <li
      className={classNames("sidebar__item", {
        "sidebar__item--active": to && pathname.includes(to),
      })}
    >
      {renderContent()}
    </li>
  );
};

export default SidebarItem;
